export const enum ContainersStep {
	FILES = "FILES",
	GROUPS = "GROUPS",
	PLACE_CONTAINERS = "PLACE_CONTAINERS",
	PLACE_VARIANTS = "PLACE_VARIANTS",
}
